"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.designSkin = void 0;
exports.designSkin = function (axios) {
    return {
        getDesignSkinSearch: function (request) {
            return axios.get('/design-skin/search', request);
        },
        postDesignSkin: function (request) {
            return axios.post('/design-skin', request.data);
        },
        getDesignSkinsOrders: function (request) {
            return axios.get('/design-skins/orders', request);
        },
        postDesignSkinsOrders: function (request) {
            return axios.post('/design-skins/orders', request.data);
        },
        getDesignSkinsProducts: function (request) {
            return axios.get('/design-skins/products', request);
        },
        postDesignSkinsProducts: function (request) {
            return axios.post('/design-skins/products', request.data);
        },
        getDesignSkinsProductsSummary: function (request) {
            return axios.get('/design-skins/products/summary', request);
        },
        putDesignSkinsOrdersOrderNoInstall: function (request) {
            var orderNo = request.pathParams.orderNo;
            return axios.put("/design-skins/orders/" + orderNo + "/install", request.data);
        },
        getDesignSkinsProductsProductNoContainersContainerNo: function (request) {
            var _a = request.pathParams, productNo = _a.productNo, containerNo = _a.containerNo;
            return axios.get("/design-skins/products/" + productNo + "/containers/" + containerNo, request);
        },
        putDesignSkinsProductsProductNoContainersContainerNo: function (request) {
            var _a = request.pathParams, productNo = _a.productNo, containerNo = _a.containerNo;
            return axios.put("/design-skins/products/" + productNo + "/containers/" + containerNo, request.data, request);
        }
    };
};
